import React from 'react'

import {useMissingKycInformation} from '@product-web/api/deimos/kyc/use-kyc-information'
import {reportError} from '@product-web/error/report'

import tracking from '~/tracking'

import {useWalletModalContext} from './wallet-modal-context'

export function useBankTransferModal() {
    const {openWalletModal} = useWalletModalContext()
    const {data: missingInformation, mutate: refreshMissingInformation} = useMissingKycInformation({
        requiredFor: 'WALLET_LOAD',
    })
    const isBankVerificationDetailsRequired = Boolean(
        missingInformation?.find(({name}) => name === 'BANK_VERIFICATION_DETAILS'),
    )

    const [bankTransferModalOptions, setBankTransferModalOptions] = React.useState<{
        onBackClick?: () => void
    }>({})

    const openBankTransferModal = React.useCallback(
        (options?: {onBackClick?: () => void}) => {
            tracking.walletBankTransferModalViewed()
            setBankTransferModalOptions(options || {})

            if (isBankVerificationDetailsRequired) {
                openWalletModal('bankVerification')
            } else {
                openWalletModal('staticTransferDetails')
            }
        },
        [isBankVerificationDetailsRequired, openWalletModal],
    )

    const onBankVerificationDone = React.useCallback(async () => {
        try {
            await refreshMissingInformation()
            openWalletModal('staticTransferDetails')
        } catch (err) {
            reportError(err)
        }
    }, [openWalletModal, refreshMissingInformation])

    return {
        openBankTransferModal,
        bankTransferModalOptions,
        onBankVerificationDone,
    }
}
